<template>
  <div class="article-detail-page">
    <div class="page-header">
      <button class="back-btn" @click="$router.back()">‹ 返回</button>
      <div class="page-title">资讯详情</div>
    </div>
    <!-- 文章头部 -->
    <div class="article-header">
      <div class="article-title">{{ article.title }}</div>
      <div v-if="article.subTitle" class="article-subtitle">{{ article.subTitle }}</div>
      <div class="article-meta">
        <div class="meta-item">{{ formatDate(article.createTime) }}</div>
      </div>
    </div>

    <!-- 文章内容 -->
    <div class="article-content">
      <div v-for="rt in richTexts" :key="rt.id" v-html="rt.content"></div>
    </div>

    <!-- 分享按钮 -->
    <div class="article-actions">
      <button class="action-btn share-btn" @click="handleShare">分享</button>
      <button class="action-btn back-btn" @click="goBack">返回</button>
    </div>
  </div>
</template>

<script>
import { getArticleDetail } from '@/api/browse'
import { formatDate } from '@/utils/format'

export default {
  name: 'ArticleDetail',
  data() {
    return {
      article: {},
      richTexts: [],
      loading: false
    }
  },
  mounted() {
    const id = this.$route.params.id
    if (id) {
      this.loadArticleDetail(id)
    }
  },
  methods: {
    async loadArticleDetail(id) {
      this.loading = true
      try {
        const res = await getArticleDetail(id)
        this.article = res.data?.article || {}
        this.richTexts = res.data?.richTexts || []
      } catch (error) {
        console.error('加载资讯详情失败:', error)
        this.$alert('加载失败，请重试')
      } finally {
        this.loading = false
      }
    },
    handleShare() {
      this.$alert('分享功能开发中')
    },
    goBack() {
      this.$router.back()
    },
    formatDate
  }
}
</script>

<style lang="scss" scoped>
.article-detail-page {
  width: 100%;
  min-height: 100vh;
  background: #f9fafb;
  padding-bottom: 80px;
}

.page-header {
  display: flex;
  align-items: center;
  background: #fff;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
  position: sticky;
  top: 0;
  z-index: 20;
}

.back-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #ff720d;
  cursor: pointer;
  margin-right: 12px;
  padding: 0;
}

.page-title { font-size: 16px; font-weight: 600; color: #111827; }

.article-header {
  background: #fff;
  padding: 20px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.article-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 8px;
  line-height: 1.4;
}

.article-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 12px;
}

.article-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.meta-item {
  font-size: 12px;
  color: #6b7280;
}

.article-content {
  background: #fff;
  padding: 20px 16px;
  margin: 12px 0;
  line-height: 1.8;
  color: #111827;
  font-size: 14px;

  ::v-deep img {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    margin: 12px 0;
  }

  ::v-deep p {
    margin: 12px 0;
  }

  ::v-deep h1,
  ::v-deep h2,
  ::v-deep h3 {
    margin: 16px 0 12px;
    font-weight: 600;
  }
}

.article-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  background: #fff;
  border-top: 1px solid #e5e7eb;
  z-index: 10;
}

.action-btn {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    opacity: 0.8;
  }
}

.share-btn {
  background: linear-gradient(90deg, #ffa43a 0%, #ff720d 100%);
  color: #fff;
}

.back-btn {
  background: #f3f4f6;
  color: #111827;
}
</style>
